import React, { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
import {
  Link,
  Box,
  Divider,
  Typography,
  List,
  ListItem,
  Tab,
  Tabs,
  Button,
  Tooltip,
  TextField,
} from "@mui/material";
import Slider from "@mui/material/Slider";
import { Chart as ChartJS, ArcElement, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import Animation from "./Animation";
import {
  ConvertToKLacCr,
  ConvertToKLacCr10K,
  numFormatter,
  numFormatter2,
} from "../../util/common";
import ToolTipText from "../Common/ToolTipText";
import { useSelector } from "react-redux";
import { API_BASE_URL } from "../../src/constant/appConstants";
import { useMutation } from "react-query";
import fetcher from "../../src/dataProvider";
import { TextFields } from "@mui/icons-material";
import { songPageGTMCTAClick } from "../../util/gtmutil";
import auth from "../Layout/util/auth";
ChartJS.register(ArcElement, Legend);

const useStyles = makeStyles((theme) => ({
  container: {
    position: "relative",
    display: "block",
    // minHeight: "100vh",
    // padding: "0 15px",
    background: "rgba(48, 39, 72, 0.9)",
    "@media(max-width:767px)": {
      padding: "0",
    },
  },
  bannerContainer: {
    display: "flex",
    flexWrap: "wrap",
    width: "100%",
    // padding: "55px 72px",
    margin: "auto",
    alignItems: "center",
    justifyContent: "center",
    "@media(max-width:480px)": {
      padding: "0px 0 0px",
    },
  },
  bannerImageContainer: {
    width: "100%",
    "@media(max-width:767px)": {
      padding: "0",
    },
  },
  investmentBox: {
    position: "relative",
    display: "block",
    background: "#19132A",
    backdropFilter: "blur(74px)",
    // padding: "20px 5px 9px",
    width: "100%",
    maxWidth: "360px",
    margin: "auto",
    color: "#fff",
    "& p": {
      color: "#fff",
      fontSize: "14px",
      fontWeight: "500",
      marginBottom: "0",
      textAlign: "left",
    },
    "& > img": {
      marginBottom: "25px",
    },
  },
  titleBox: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    "& img": {
      marginRight: "32px",
    },
    "& div": {
      color: "#fff",
      fontSize: "18px",
      fontWeight: "500",
    },
  },
  lineSeparator: {
    position: "relative",
    display: "block",
    width: "100%",
    margin: "15px 0",
    borderBottom: "1px solid #fff",
    opacity: "0.5",
  },
  rangeSliderBox: {
    width: "100%",
    position: "relative",
    display: "block",
    margin: "0 auto 15px",
    borderRadius: "10px",
    padding: "10px 0",
    "& .MuiSlider-thumb": {
      background: "#fff",
      borderRadius: "4px",
      minWidth: "20px",
      height: "20px",
      color: "#000",
      "&:after": {
        display: "none !important",
      },
      "&:hover": {
        boxShadow: "none",
      },
    },
    "& .MuiSlider-root": {
      height: "2px",
      marginBottom: "0",
    },
    "& .MuiSlider-track": {
      background: "#E94177",
      border: "none",
    },
    "& .MuiSlider-mark": {
      background: "#511F49",
      width: "1px",
      height: "10px",
    },
    "& .MuiSlider-markActive": {
      background: "#E94177",
    },
    "& .MuiSlider-rail": {
      background: "#511F49",
      opacity: "1",
    },
    "& .MuiSlider-valueLabel": {
      top: "0",
      color: "#fff",
      padding: "0 7px",
      height: "36px",
      minWidth: "72px",
      borderRadius: "8px",
      fontSize: "10px",
      background:
        "linear-gradient(90.48deg, #E14084 3.73%, #3454FA 53.09%, #54B5BB 96.58%)",
      position: "relative",
      transform: "none !important",
      "&:before": {
        display: "none",
      },
    },
    "& .MuiSlider-markLabel": {
      color: "rgba(255, 255, 255, 0.7)",
      fontSize: "10px",
      top: "19px",
    },
  },
  content: {
    fontSize: "14px",
    fontWeight: "400",
    // marginBottom: "16px",
  },
  contentDiabled: {
    fontSize: "14px",
    fontWeight: "400",
    margin: "16px 0 32px",
    color: "rgba(255, 255, 255, 0.5)",
  },
  earnings: {
    position: "relative",
    display: "flex",
    alignItems: "center !important",
    justifyContent: "space-between",
    marginBottom: "20px",
  },
  nftOptions: {
    position: "relative",
    display: "block",
    marginBottom: "38px",
  },
  nftCards: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingTop: "10px",
    listStyle: "none",
    "& li": {
      position: "relative",
      display: "block",
      width: "95px",
      height: "95px",
      padding: "12px",
      borderRadius: "12px",
      cursor: "pointer",
    },
    "& li.silver": {
      background: "center / cover no-repeat url(/images/calculator/silver.jpg)",
    },
    "& li.gold": {
      background: "center / cover no-repeat url(/images/calculator/gold.jpg)",
    },
    "& li.silver.active,& li.gold.active,& li.platinum.active": {
      "&:before": {
        content: "''",
        position: "absolute",
        top: "-1px",
        left: "-1px",
        right: "-1px",
        bottom: "-18px",
        background:
          "linear-gradient(90.48deg, #E14084 3.73%, #3454FA 53.09%, #54B5BB 96.58%)",
        borderRadius: "12px",
        zIndex: "-1",
      },
      "&:after": {
        content: "'SELECTED'",
        position: "absolute",
        fontSize: "9px",
        fontWeight: "400",
        bottom: "-15px",
        borderRadius: "12px",
        width: "100%",
        left: "0",
        textAlign: "center",
      },
    },
    "& li.platinum": {
      background:
        "center / cover no-repeat url(/images/calculator/platinum-new.svg)",
    },
  },

  tradingNftCards: {
    marginTop: "20px",
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0",
    listStyle: "none",
    "& li": {
      position: "relative",
      display: "block",
      // width: "95px",
      maxHeight: "120px",
      padding: "8px",
      borderRadius: "12px",
      cursor: "pointer",
    },
    "& li.silver": {
      background:
        "center / cover no-repeat url(/images/calculator/trade-silver1.svg)",
    },
    "& li.silver.active,& li.gold.active,& li.platinum.active": {
      "&:before": {
        content: "''",
        position: "absolute",
        top: "0px",
        left: "0px",
        right: "0px",
        background:
          "linear-gradient(90.48deg, #E14084 3.73%, #3454FA 53.09%, #54B5BB 96.58%)",
        borderRadius: "12px",
        zIndex: "-1",
      },
    },
  },
  cardTitle: {
    fontSize: "16px",
    fontWeight: "800",
    marginBottom: "6px",
  },
  cardRate: {
    fontSize: "12px",
    fontWeight: "600",
    marginBottom: "16px",
  },
  tradeCardRate: {
    fontSize: "14px",
    fontWeight: "500",
    marginBottom: "6px",
  },
  tradeRoyaltyValue: {
    fontSize: "14px",
    fontWeight: "400",
  },
  royaltyValue: {
    fontSize: "9px",
    fontWeight: "400",
  },
  donutChart: {
    position: "relative",
    display: "block",
    border: "1px solid rgba(255, 255, 255, 0.5)",
    borderRadius: "12px",
    padding: "10px 0",
  },

  graphContent: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& span": {
      color: "rgba(255, 255, 255, 0.5)",
      fontSize: "14px",
      fontWeight: "400",
      padding: "0 25px",
      position: "relative",
    },
    "& span:before": {
      content: "''",
      position: "absolute",
      width: "12px",
      height: "12px",
      borderRadius: "4px",
      left: "6px",
      top: "4px",
    },
    "& span:first-child:before": {
      background:
        "linear-gradient(90.48deg, #E14084 3.73%, #3454FA 53.09%, #54B5BB 96.58%)",
    },
    "& span:last-child:before": {
      background: "#fff",
    },
  },
  contentValue: {
    background: "#E14084",
    borderRadius: "8px",
    alignItems: "flex-start",
    padding: "4px 8px",
    maxHeight: "24px",

    fontSize: "14px",
    fontWeight: "700",
    marginBottom: "8px",
    marginTop: "3px",
  },
  quantity: { display: "flex", alignItems: "center", paddingRight: "5px" },
  redeemCoinInput: {
    background: "#FFFFFF",
    borderRadius: "4px",
    marginTop: "3px",
    width: "100px",
    textAlign: "center",
    fontWeight: 600,
    marginRight: "15px",
    "&:focus-visible": {
      outline: "none",
    },
    "& .MuiInput-root": {
      "&:before, :after, :hover:not(.Mui-disabled):before": {
        borderBottom: 0,
      },
    },
  },
  confirmQuantity: {
    position: "relative !important",
    fontWeight: "600 !important",
    fontSize: "12px !important",
    border: "1px solid #fff !important",
    lineHeight: "28px !important",
    borderRadius: "16px !important",
    marginTop: "8px !important",
    height: "30px !important",
    color: "#fff !important",
    maxWidth: "70px !important",
    textTransform: "capitalize !important",
  },
  confirmQuantityColour: {
    position: "relative !important",
    fontWeight: "600 !important",
    maxWidth: "70px !important",
    background: "linear-gradient(90deg,#E14084,#3454FA,#54B5BB) !important",
    fontSize: "12px !important",
    lineHeight: "28px !important",
    borderRadius: "16px !important",
    alignItems: "center !important",
    marginTop: "8px !important",
    height: "30px !important",
    color: "#fff !important",
    textTransform: "capitalize !important",
  },
  tradeCardTitle: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "& div": {
      fontSize: "20px",
      fontWeight: "600",
      marginBottom: "6px",
    },
    "& p:last-child": {
      // color: "#E14084",
      fontWeight: "700",
    },
    "@media (max-width:767px)": {
      fontSize: "16px",
      fontWeight: "600",
      "& div": {
        fontSize: "20px",
        fontWeight: "600",
        marginBottom: "5px",
      },
    },
  },
}));

export default function Index(props) {
  const {
    tierData,
    defaultStream = 200,
    defaultNft = false,
    is_tradable = false,
  } = props;
  const classes = useStyles();
  const [slidervalue, setSliderValue] = React.useState(defaultStream || 200);
  const [songEarning, setSongEarning] = React.useState(0);
  const [expectedReturn, setExpectedReturn] = React.useState(0);
  const [quantityInput, setQuantityInput] = useState(1);
  const [isPlaceOrderActive, setIsPlaceOrderActive] = useState(true);
  const [OneNftprice, setOneNftprice] = useState(0);
  const [tradingRoyaltyShare, setTradingRoyaltyShare] = React.useState();
  const [count, setCount] = useState(1);
  const [selectedCard, setSelectedCard] = React.useState(
    (defaultNft && tierData.find((item) => item.id == defaultNft)) ||
      tierData[0]
  );
  const { country_code } = useSelector((state) => state.layout);
  const handleChange = (event, newValue) => {
    setSliderValue(newValue);
  };

  function valueLabelFormat(value) {
    if (country_code == "IN") {
      return `${value} Mn`;
      // return `${value / 10} Cr`;
    } else {
      return `${value} Mn`;
    }
  }
  function valuetext(value) {
    return `${value}mn`;
  }
  useEffect(() => {
    let temp = slidervalue * 1000000 * 0.04;
    setSongEarning(temp);
    let returns =
      (slidervalue * 1000000 * 0.04 * selectedCard?.attributes?.revenue_share) /
      100;
    setExpectedReturn(returns);
  }, [slidervalue, selectedCard]);

  useEffect(() => {
    if (is_tradable) {
      let temp = slidervalue * 1000000 * 0.04;
      setSongEarning(temp);
      let returns = (slidervalue * 1000000 * 0.04 * tradingRoyaltyShare) / 100;
      setExpectedReturn(returns);
    }
  }, [tradingRoyaltyShare]);

  useEffect(() => {
    if (is_tradable) {
      var obj = {
        tierId: selectedCard?.attributes?.tier_id,
        quantity: count,
      };
      getTradingPriceReturnCalc(obj);
    }
  }, [count]);

  const { mutate: getTradingPriceReturnCalc } = useMutation(
    (obj) => fetcher.post(`${API_BASE_URL}/v1/nft/get-trading-price`, obj),
    {
      onSuccess: (response) => {
        setOneNftprice(response.data.buyPrice * count);
        setTradingRoyaltyShare(
          (selectedCard.attributes?.revenue_share * count).toFixed(4)
        );
      },
      onError: (error) => {
        console.log("Error", error.response.data);
        setCount(1);
        setQuantityInput(1);
        alert(error.response.data.message);
      },
    }
  );

  const handleQuantityConfirm = () => {
    songPageGTMCTAClick(
      auth(),
      "ctaClicks",
      "Buy nft",
      "Quantity Confirm",
      "loggedIn",
      "Guest",
      selectedCard?.attributes?.description_asset_tier_mnemonics?.split("|")[0]
    );
    setCount(quantityInput);
    setIsPlaceOrderActive(true);
  };

  return (
    <>
      <Box className={classes.container}>
        <Box className={classes.bannerContainer}>
          <Box className={classes.bannerImageContainer}>
            <Box className={classes.investmentBox}>
              <Box className={classes.rangeSliderBox}>
                <Box className={classes.content}>
                  Total Stream Projection{" "}
                  <Tooltip
                    enterTouchDelay={0}
                    leaveTouchDelay={6000}
                    arrow
                    title={
                      <ToolTipText text="Projected sum of Streams for all streaming partners (Spotify, Gaana, Saavn, Wynk etc) and Total Views on Youtube." />
                    }
                    placement="top-start"
                    TransitionProps={{ leavedelay: 5000 }}
                  >
                    <Box
                      mt={"-5px"}
                      component="img"
                      src="/images/calculator/info.svg"
                    />
                  </Tooltip>
                </Box>
                <Slider
                  value={slidervalue}
                  min={1}
                  step={25}
                  max={1000}
                  defaultValue={5}
                  getAriaValueText={valuetext}
                  valueLabelFormat={valueLabelFormat}
                  onChange={handleChange}
                  valueLabelDisplay="auto"
                  aria-labelledby="non-linear-slider"
                  marks
                />
              </Box>
              <Box className={classes.earnings}>
                <Box className={classes.content}>
                  Song Earnings{" "}
                  <Tooltip
                    enterTouchDelay={0}
                    leaveTouchDelay={6000}
                    arrow
                    title={
                      <ToolTipText text="Projected song earnings (total stream projection x revenue per stream) from all streaming partners (Spotify, Gaana, Saavn, Wynk etc) and from Youtube." />
                    }
                    placement="top-start"
                    TransitionProps={{ leavedelay: 5000 }}
                  >
                    <Box
                      mt={"-5px"}
                      component="img"
                      src="/images/calculator/info.svg"
                    />
                  </Tooltip>
                </Box>
                <Box className={classes.contentValue}>
                  {" "}
                  {ConvertToKLacCr(songEarning, country_code)}
                </Box>
              </Box>
              <Divider className={classes.lineSeparator} />
              <Box className={classes.nftOptions}>
                <Box className={classes.content}>Choose NFT</Box>
                {is_tradable ? (
                  <>
                    <List className={classes.tradingNftCards}>
                      {tierData.map((item, i) => (
                        <ListItem
                          key={i}
                          className="silver active"
                          onClick={() => setSelectedCard(item)}
                        >
                          <Box
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItem: "center",
                            }}
                          >
                            <Box>
                              <Box className={classes.tradeCardTitle}>
                                <Typography component="div">
                                  {item.attributes.asset_tier_mnemonics}
                                </Typography>
                              </Box>
                              <Box className={classes.tradeCardRate}>
                                {country_code == "IN" ? (
                                  <>₹{Math.round(OneNftprice * 80)}</>
                                ) : (
                                  <> ${OneNftprice.toFixed(2)} </>
                                )}
                              </Box>
                              <Box className={classes.tradeRoyaltyValue}>
                                Royalty:{tradingRoyaltyShare}%{" "}
                              </Box>
                            </Box>
                            <Box className={classes.quantity}>
                              <Box display="flex" flexDirection="column">
                                <Typography>Quantity </Typography>
                                <TextField
                                  hiddenLabel
                                  autoComplete="off"
                                  className={classes.redeemCoinInput}
                                  // error={false}
                                  id="outlined-error-helper-text"
                                  size="small"
                                  disableUnderline={false}
                                  inputProps={{
                                    style: {
                                      height: "15px",
                                      padding: "3 8px",
                                      fontWeight: 600,
                                    },
                                    disableUnderline: true,
                                    underline: {
                                      "&&:before": {
                                        borderBottom: "none",
                                      },
                                      "&&:after": {
                                        borderBottom: "none",
                                      },
                                    },
                                  }}
                                  variant="filled"
                                  onChange={(e) => {
                                    setIsPlaceOrderActive(
                                      e.target.value != "" ? false : true
                                    ),
                                      setQuantityInput(
                                        e.target.value.replace(/\D/g, "")
                                      );
                                  }}
                                  value={quantityInput}
                                  style={{ width: 70 }}
                                />
                                {!isPlaceOrderActive ? (
                                  <Button
                                    className={classes.confirmQuantityColour}
                                    onClick={handleQuantityConfirm}
                                  >
                                    confirm
                                  </Button>
                                ) : (
                                  <Button
                                    className={classes.confirmQuantity}
                                    style={{
                                      cursor: "default",
                                      opacity: "0.6",
                                    }}
                                  >
                                    confirm
                                  </Button>
                                )}
                              </Box>
                            </Box>
                          </Box>
                        </ListItem>
                      ))}
                    </List>
                  </>
                ) : (
                  <List className={classes.nftCards}>
                    {tierData.map((item, i) => (
                      <ListItem
                        key={i}
                        className={
                          i == 0 && selectedCard?.id == item.id
                            ? "silver active"
                            : i == 1 && selectedCard?.id == item.id
                            ? "gold active"
                            : i == 2 && selectedCard?.id == item.id
                            ? "platinum active"
                            : i == 0
                            ? "silver"
                            : i == 1
                            ? "gold"
                            : "platinum"
                        }
                        onClick={() => setSelectedCard(item)}
                      >
                        <Box className={classes.cardTitle}>
                          {item.attributes.asset_tier_mnemonics}
                        </Box>
                        <Box className={classes.cardRate}>
                          {country_code == "IN" ? (
                            <>
                              ₹ {Math.round(item.attributes.starting_bid * 80)}
                            </>
                          ) : (
                            <> ${item?.attributes?.starting_bid} </>
                          )}
                        </Box>
                        <Box className={classes.royaltyValue}>
                          Royalty:{item.attributes.revenue_share}%{" "}
                        </Box>
                      </ListItem>
                    ))}
                  </List>
                )}
              </Box>
              <Box className={classes.earnings}>
                <Box className={classes.content}>
                  Expected Return{" "}
                  <Tooltip
                    enterTouchDelay={0}
                    leaveTouchDelay={6000}
                    arrow
                    title={
                      <ToolTipText text="Expected return you will earn which is equal to Total song Earnings x your royalty share (based on NFT you purchase)." />
                    }
                    placement="top-start"
                    TransitionProps={{ leavedelay: 5000 }}
                  >
                    <Box
                      mt={"-5px"}
                      component="img"
                      src="/images/calculator/info.svg"
                    />
                  </Tooltip>
                </Box>
                <Box className={classes.contentValue}>
                  {ConvertToKLacCr10K(expectedReturn, country_code)}
                </Box>
              </Box>
              <Divider className={classes.lineSeparator} />
              <Box className={classes.donutChart}>
                <Box className={classes.graphContent}>
                  <Typography component="span">
                    My Return (
                    {is_tradable && OneNftprice
                      ? (expectedReturn / 80 / OneNftprice).toFixed(1)
                      : (
                          expectedReturn /
                          80 /
                          selectedCard?.attributes?.starting_bid
                        ).toFixed(1)}
                    x){" "}
                  </Typography>
                  <Typography component="span">Investment</Typography>
                </Box>
                {expectedReturn &&
                  ((is_tradable && OneNftprice) ||
                    selectedCard?.attributes?.starting_bid) && (
                    <Animation
                      expectedReturn={expectedReturn}
                      selectedCard={
                        is_tradable
                          ? OneNftprice
                          : selectedCard?.attributes?.starting_bid
                      }
                    ></Animation>
                  )}
              </Box>
              <Divider className={classes.lineSeparator} />
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
}
